import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box component={Typography} fontWeight={700} variant="h3" gutterBottom align="center" color={theme.palette.primary.main}>
          Dr. Condominio Radio: La voz de la convivencia y el bienestar inmobiliario
        </Box>
        <Typography variant="h6" component="p" color="textSecondary" align="center">
          El espacio líder dedicado a la asesoría, gestión y soluciones para la vida en comunidad. Transformamos los retos de la propiedad horizontal en herramientas de sana convivencia, creando una plataforma de confianza donde las marcas se integran como soluciones directas a las necesidades del hogar y el patrimonio.
        </Typography>
        <Box display="flex" justifyContent="center" sx={{ my: 3 }}>
          <Box
            component="img"
            src="https://files.tnonetwork.com/shows/logo/doctorcondominioradio.png"
            alt="Dr. Condominio Radio"
            sx={{ maxWidth: 200, height: 'auto', objectFit: 'contain' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </Box>
        <Typography variant="h5" component="p" color={theme.palette.primary.main} align="center" sx={{ mb: 2, fontStyle: 'italic' }}>
          ¿Qué es Dr. Condominio?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/doctorcondominioradio"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/doctorcondominioradio
          </Link>
        </Typography>
        <Typography variant="body1" component="p" color="textSecondary" align="center" sx={{ mt: 1 }}>
          Es un ecosistema de contenido diseñado para copropietarios, juntas de condominio y administradores que buscan proteger su inversión y mejorar su calidad de vida. Nos enfocamos en soluciones legales, técnicas y de mantenimiento con un lenguaje claro, dinámico y, sobre todo, resolutivo. En <strong>Dr. Condominio</strong>, convertimos la gestión inmobiliaria en un proceso eficiente y transparente. Transmisión en vivo por TNO Network.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="/images/doctorcondominio.jpg"
                alt="Dr. Julio César López Galea - Dr. Condominio Radio"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  objectPosition: 'center',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography variant="h5" fontWeight={700} gutterBottom color={theme.palette.primary.main}>
              NUESTRA ANCLA: DR. JULIO CÉSAR LÓPEZ GALEA
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', mb: 2 }}>
              La autoridad jurídica y técnica que el mercado inmobiliario respeta.
            </Typography>
            <Typography variant="body1" color="textSecondary">
              El <strong>Dr. Julio César López Galea</strong> lidera este espacio con una trayectoria impecable en el derecho y la gestión de condominios. Su profundo conocimiento de la normativa venezolana y su enfoque práctico para resolver conflictos lo convierten en la figura de mayor credibilidad en el sector. Su liderazgo asegura que cada marca patrocinante cuente con el respaldo de una autoridad reconocida, garantizando que el mensaje comercial sea recibido con confianza y seriedad por quienes toman las decisiones.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string,
};

export default Who;
